var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Copy_Link",
    "data-name": "Copy Link",
    transform: "translate(-607 -311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_60_1",
    "data-name": "Component 60 \\u2013 1",
    transform: "translate(607 311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10673",
    "data-name": "Rectangle 10673",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32045",
    "data-name": "Group 32045",
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10674",
    "data-name": "Rectangle 10674",
    transform: "translate(2.563 2.503)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.667,
    height: 15.375,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 12.167,
    height: 13.875,
    rx: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M0,0H10.25",
    transform: "translate(0 10.25) rotate(-90)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16981",
    "data-name": "Path 16981",
    d: "M0,0H10.25",
    transform: "translate(10.25 0) rotate(180)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7d084d13.svg";
export { ForwardRef as ReactComponent };